<template>
  <div>
    <div
      v-for="(item, index) in list"
      :key="index"
      class="cartoon-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <van-image
        width="330"
        height="462"
        class="video-img"
        :src="item.thumb_img"
      >
        <template v-slot:loading>
          <van-image
            width="127"
            height="82"
            class="video-img"
            :src="require('@/assets/default.png')"
          />
        </template>
        <template v-slot:error
          ><van-image
            width="127"
            height="82"
            class="video-img"
            :src="require('@/assets/default.png')"
        /></template>
      </van-image>
      <div class="title-main">
        <div class="title" v-html="item.title"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      // this.$router.push({
      //   path: "/wallchart/" + id,
      // });
      const detail = this.$router.resolve({ path: "/wallchart/" + id });
      window.open(detail.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.cartoon-content {
  position: relative;
  display: inline-block;
  width: 330px;
  height: 462px;
  margin-top: 30px;
  margin-left: 55px;
  cursor: pointer;

  .title-main {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 94px;
    background: #000;
    opacity: 0.8;

    .title {
      display: -webkit-box; /* stylelint-disable-line */
      display: -ms-flexbox; /* stylelint-disable-line */
      width: 295px;
      height: 55px;
      margin-top: 21px;
      margin-left: 22px;
      overflow: hidden;
      font-size: 18px;
      font-weight: 400;
      line-height: 30px;
      color: #fff;
      text-overflow: ellipsis;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      ::v-deep span {
        color: rgb(0 71 255 / 100%);
      }
    }
  }
}

// .cartoon-content + .cartoon-content {
//   margin-left: 60px;
// }
</style>
